import React, {useEffect, useState} from 'react';
import './DashboardItems.scss';
import {ArrowIcon, EndDateIcon, ShowReport, ShowTracking, StartDateIcon} from "../DashboardTypeSVG/DashboardTypeSVG";
import NumericFunction from "../../../../../utils/NumericFunction";
import ModalFollowUp from "../../../../../Components/FollowUpPage/ModalFollowUp";
import ModalTaskReport from "./ModalTaskReport";

const TaskItemBox = ({data, setRefreshData, refreshData}) => {

  const [currentTab, setCurrentTab] = useState(1);
  const [componentData, setComponentData] = useState([]);
  const [showModalTrack, setShowModalTrack] = useState(false);
  const [showModalTask, setShowModalTask] = useState(false);
  const [modalData, setModalData] = useState({})

  useEffect(() => {
    if (currentTab === 1) {
      setComponentData(data?.openTasks)
    } else if (currentTab === 2) {
      setComponentData(data?.pendingTasks)
    } else if (currentTab === 3) {
      setComponentData(data?.awaitingTasks)
    } else if (currentTab === 4) {
      setComponentData(data?.archivedTasks)
    }
  }, [currentTab, data]);

  const showReportDetailHandler = (data) => {
    let temp = [...componentData]
    temp.forEach((item) => {
      if (item?.number === data?.number) {
        item.showDetail = !item.showDetail
      }
    })
    setComponentData(temp)
  }

  try {
    return (
      <div className="TaskItemBox box-sec">
        <div className={"row-tab-change"}>
          <h6 onClick={() => setCurrentTab(1)}
              style={currentTab === 1 ? {backgroundColor: "#FFBD35"} : {backgroundColor: "#FFFFFF"}}>تسک باز</h6>
          <h6 onClick={() => setCurrentTab(2)}
              style={currentTab === 2 ? {backgroundColor: "#FFBD35"} : {backgroundColor: "#FFFFFF"}}>تسک معلق</h6>
          <h6 onClick={() => setCurrentTab(3)}
              style={currentTab === 3 ? {backgroundColor: "#FFBD35"} : {backgroundColor: "#FFFFFF"}}>در انتظار
            تایید</h6>
          <h6 onClick={() => setCurrentTab(4)}
              style={currentTab === 4 ? {backgroundColor: "#FFBD35"} : {backgroundColor: "#FFFFFF"}}>بایگانی</h6>
        </div>
        {(currentTab === 1) &&
          <ul className={"current-box"} style={{height: '40vh'}}>
            {componentData.length > 0 ?
              componentData.map((task, index) =>
                <li key={index + "op"}>
                  <div className={"detail-task"}>
                  <span>
                    <h6>{task?.number}</h6>
                    <h6>:</h6>
                    <h6>{task?.title}</h6>
                  </span>
                    <span className={"date-side"} style={{justifyContent: "center"}}>
                      <div className="inline-date">
                        <StartDateIcon/>
                        <h6>{NumericFunction.e2p(task.startDate)} ، </h6>
                        <h6>{NumericFunction.e2p(task.startTime)}</h6>
                      </div>
                      <div className="inline-date">
                        <EndDateIcon/>
                        <h6>{NumericFunction.e2p(task.endDate)} ، </h6>
                        <h6>{NumericFunction.e2p(task.endTime)}</h6>
                      </div>
                    </span>
                    <span className={"button-side"}>
                    <button onClick={() => {
                      setModalData(task)
                      setShowModalTrack(true)
                    }}>
                      <ShowTracking/>
                    </button>
                    <button onClick={() => {
                      setModalData(task)
                      setShowModalTask(true)
                    }}>
                      <ShowReport/>
                    </button>
                  </span>
                  </div>
                  <div className={"show-percentage"}>
                    <div style={{backgroundColor: task?.color, width: task?.percentage + "%"}}
                         className={"color-show"}></div>
                    <h6 style={+task?.percentage > 0 ? {left: (+task?.percentage - 1) + "%"} :
                      {left: (+task?.percentage) + "%"}}>{"%" + " " + task?.percentage}</h6>
                  </div>
                </li>) : <li><h6>تسک ندارید</h6></li>
            }
          </ul>
        }

        {(currentTab === 2 || currentTab === 3 || currentTab === 4) &&
          <ul className={"current-box"} style={{height: '40vh'}}>
            {componentData.length > 0 ?
              componentData.map((task, index) =>
                <li key={index + "op"}>
                  <div className={"detail-task"}>
                  <span>
                    <h6>{task?.number}</h6>
                    <h6>:</h6>
                    <h6>{task?.title}</h6>
                  </span>
                    {currentTab !== 2 &&
                      <span className={"date-side"} style={{justifyContent: "center"}}>
                        <div className="inline-date">
                          <EndDateIcon/>
                          <h6>{NumericFunction.e2p(task.endDate)} ، </h6>
                          <h6>{NumericFunction.e2p(task.endTime)}</h6>
                        </div>
                      </span>}
                    <span className={"arrow-but"}>
                    {currentTab !== 2 && <button onClick={() => showReportDetailHandler(task)}
                                                 className={+task?.showDetail === 1 && "be-rotate"}>
                      <ArrowIcon/>
                    </button>
                    }
                  </span>
                  </div>
                  {+task?.showDetail === 1 &&
                    <div className={"showDetail"}>
                      {task?.reports.map((report, row) =>
                        <div className={"showDetail-row"} key={"r" + row}>
                          <h6>{report?.description}</h6>
                          <div className="inline-date">
                            <StartDateIcon/>
                            <h6>{NumericFunction.e2p(report.date)}</h6>
                          </div>
                        </div>
                      )}
                    </div>
                  }
                </li>) : <li><h6>تسک ندارید</h6></li>
            }
          </ul>
        }
        {showModalTrack && <ModalFollowUp listName={modalData?.listname}
                                          pkValue={modalData?.number}
                                          setShowModal={setShowModalTrack}
                                          onClose={() => setShowModalTrack(false)}/>}

        {showModalTask && <ModalTaskReport onClose={() => setShowModalTask(false)}
                                           data={modalData}
                                           setRefreshData={setRefreshData}
                                           refreshData={refreshData}/>}
      </div>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default TaskItemBox;